import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { key: 4 }

import { reactive, computed, onMounted, ref } from 'vue'
import { findByRoadAreaConfig } from '@/api/yuntuSales/roadAreaConfig'
import {
  clientsStatusEnum,
  customerTypeEnum,
  remanentFollowDayTypeEnum,
  customerUnfollowDayTypeEnum,
  tmsCustomerValueEnum, favoriteStatus, clueAndcustomerPhaseEnum, customerAllStatusEnum
} from '@/views/yuntuSales/commonEnum/dataConfig'
import { useRouter, useRoute } from 'vue-router'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { addToFav, cancelToFav, listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'

const __default__ = { name: 'DcCosLbuRoadAreaConfigReport' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const totalCount = ref(0)
const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  sortCollection: 1,
  timeType: 1,
  contact: {
    type: 1
  }
})
const paramCodeData = reactive<{
  lbu_customer_business_area: []
  lbu_sales_category: []
  lbu_cargo_type: []
  lbu_logistics_service_provider: []
  lbu_shipping_channel: []
  lbu_daily_traffic: []
  lbu_sale_platform: []
  lbu_demand_country: []
  lbu_erp_info: []
  lbu_loss_reason: []
  lbu_important: [],
  lbu_customer_grade: []
}>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_loss_reason: [],
  lbu_important: [],
  lbu_customer_grade: [],
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_loss_reason',
      'lbu_important',
      'lbu_customer_grade'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handledQueryParams = (params: any) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(params)
  findByRoadAreaConfig({
    ...queryForm
  }).then((res) => {
    totalCount.value = res?.data?.totalCount || 0
    callBack(res)
  })
}

const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}

// const statusEnum = clientsStatusEnum.map((item) => ({
//   name: item.label,
//   value: item.value,
//   color: item.color
// }))
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: 'ID', dataIndex: 'cosId', width: 200 },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '客户状态', dataIndex: 'status', dicData: customerAllStatusEnum },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '客户标签', dataIndex: 'customerLabel' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '来源渠道', dataIndex: 'channel', width: 150 },
  { title: '渠道代码', dataIndex: 'tmsChannelCode' },
  { title: '客户类型', dataIndex: 'type', dicData: customerTypeEnum },
  { title: '客户等级', dataIndex: 'grade', dicData: paramCodeData.lbu_customer_grade },
  { title: '未跟进天数', dataIndex: 'unfollowDays' },
  { title: '剩余跟进天数', dataIndex: 'remanentFollowDays' },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '备注', dataIndex: 'remark' },
  {
    title: '业务收入等级',
    dataIndex: ['business', 'monthIncome'],
    dicData: paramCodeData.lbu_important
  },
  { title: '年销售GMV（元）', dataIndex: ['business', 'annualSales'], type: 'money', width: 150, sorter: true },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '转为成交时间', dataIndex: 'turnedTransaction', width: 190, sorter: true },
  { title: '转为潜在时间', dataIndex: 'turnedPotential', width: 190, sorter: true },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true }
])

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "cosId",
            "row-selection": { onChange: onSelectChange },
            serial: "",
            columns: columns.value,
            tableId: "lbuClients",
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[13] || (_cache[13] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: "客户名称",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: "客户代码",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.tmsCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.tmsCode) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerSerial,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerSerial) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.cosId) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "路区代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.roadAreaCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.roadAreaCode) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户阶段" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.stageList,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.stageList) = $event)),
                        placeholder: "请选择",
                        "allow-clear": "",
                        mode: "multiple",
                        options: _unref(clueAndcustomerPhaseEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: queryForm.sellerList,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.sellerList) = $event)),
                        mode: "multiple"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.customerRegionList,
                        "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.customerRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: queryForm.channelList,
                            "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.channelList) = $event)),
                            appId: "cos_lbu",
                            paramCode: "lbu_source_channel",
                            style: {"width":"33%"}
                          }, null, 8, ["ids"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.channelExplain,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.channelExplain) = $event)),
                            maxlength: 100,
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间查询" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.timeType) = $event)),
                            style: {"width":"33%"},
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("创建时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("首次领取时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("最后一次领取时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("转为潜在时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("转为成交时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 6 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("更新时间")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_cos_range_picker, {
                            style: {"width":"67%"},
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.endTime) = $event))
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "334",
                search: handledQueryParams(queryForm),
                totalCount: totalCount.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search", "totalCount"])), [
                [_directive_permission, 'lbu_road_area_config_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text,index }) => [
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_router_link, {
                      to: record.stage === 1 ? `/lbu/salesClue/view?clueId=${record.cosId}` : (record.stage === 2 ? `/lbu/potential/view?cosId=${record.cosId}` : `/lbu/clients/view?cosId=${record.cosId}`),
                      class: "ant-table-cell-ellipsis",
                      title: text
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text || '--'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "title"])
                  ]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channel')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 1,
                    appId: "cos_lbu",
                    paramCode: "lbu_source_channel",
                    value: text,
                    desc: record.channelExplain
                  }, null, 8, ["value", "desc"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 2,
                    appId: "cos_lbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerLabel')
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(record.customerLabel ? record.customerLabel.map((item) => item ).join('、') : '--'), 1))
                : _createCommentVNode("", true),
              (column.type === 'money')
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})